import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'
import { BiometricsToggle } from '@mobi/account/Areas/Biometrics/Components/BiometricsToggle'
import { useBiometricsStatus } from '@mobi/account/Areas/Biometrics/Hooks/useBiometricsStatus'
import { spacing } from '@mobi/component-library/Foundations'
import { AppVersion, isReactNativeApp } from '@mobi/web-native-comms/web'
import { getBiometricsToggleText } from '../../helpers/getBiometricsToggleText'

export const LoginMainBiometricsToggle = ({
  isDisabled,
  onToggle,
  onStatusChanged,
}: {
  isDisabled?: boolean
  onToggle: (newValue: boolean, isDifferent: boolean) => void
  onStatusChanged?: (isBiometricsStatusReady: boolean) => void
}) => {
  const [isBiometricsToggleOn, setIsBiometricsToggleOn] = useState(false)
  const { isBiometricsStatusReady, isBiometricsEnabled, biometricsStatus } = useBiometricsStatus()

  useEffect(
    () => {
      if (isBiometricsStatusReady) {
        setIsBiometricsToggleOn(isBiometricsEnabled)
        onStatusChanged?.(isBiometricsStatusReady)
        onToggle(isBiometricsEnabled, false)
      }
    },
    // note we don't want the onStatusChanged & onToggle handlers as deps here or it
    // creates a bug where the toggle doesn't work properly cause the status keeps
    // getting reset. This should really be fixed by having a proper event in useBiometricsStatus
    // on status change instead of just having to check changes in the returned value
    [isBiometricsStatusReady, isBiometricsEnabled]
  )

  const reactNativeAppVersion = +(AppVersion?.split('.', 1)[0] ?? 0)
  const promptText = getBiometricsToggleText(biometricsStatus?.biometricsType)

  if (!isReactNativeApp || reactNativeAppVersion < 239) {
    return null
  }

  return (
    <BiometricsToggleWrapper>
      <BiometricsToggle
        text={promptText}
        isDisabled={isDisabled || !isBiometricsStatusReady}
        toggleState={isBiometricsToggleOn}
        onToggle={newValue => {
          setIsBiometricsToggleOn(newValue)
          onToggle(newValue, newValue != isBiometricsEnabled)
        }}
        toggleTitle='Enable/Disable'
      />
    </BiometricsToggleWrapper>
  )
}

const BiometricsToggleWrapper = styled.div({
  '> div': {
    color: 'white',
    justifyContent: 'flex-end',
    margin: '3.9rem 0 1.4rem',
    gap: spacing.md,
  },
})
